import { ICurrencyConversionRate } from "@faire/web-api/indigofair/data/ICurrencyConversionRate";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getCurrencyConversionRate = ():
  | ICurrencyConversionRate
  | undefined => {
  return getGlobalProperty<ICurrencyConversionRate>("currencyConversionRate");
};
